import debug from "debug";

const log: debug.Debugger = debug("satori-text-fit");

export default log;
